<template>
    <form-generator
        v-model="reactiveValue"
        :schema="formSchema"
        value-class=""
    ></form-generator>
</template>

<script>
import HocFormGenerator from '@/components/FormGenerator/HocFormGenerator';
import FormLayout from './UserFormLayout';
import { checkEmail, checkUsername } from '@/common/validationRules';

const FormGenerator = HocFormGenerator(FormLayout);

export default {
    name: 'UserEditForm',
    components: {
        'form-generator': FormGenerator
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => {}
        },
        allowXocField: {
            type: Boolean,
            default: false
        },
        xocAuth: {
            type: Boolean,
            default: false
        },
        isNewRecord: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ''
        },
        prefixItems: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        reactiveValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
        xocAuthField() {
            if (this.allowXocField) {
                return {
                    name: 'xocAuth',
                    label: 'MSO user',
                    component: {
                        type: 'v-checkbox',
                        props: {
                            dense: false,
                            hideDetails: true,
                            disabled: !this.isNewRecord
                        }
                    }
                };
            }
            return {
                name: 'placeHolder',
                label: 'placeholder'
            };
        },
        usernameField() {
            let rules = [];
            if (this.isNewRecord && this.xocAuth) {
                rules = [v => checkUsername(v, 'Username', this.prefix)];
            }
            if (this.xocAuth) {
                return {
                    name: 'username',
                    hideLable: true,
                    component: {
                        type: 'v-text-field',
                        props: {
                            label: 'Username *',
                            dense: true,
                            required: true,
                            maxlength: 254,
                            rules: rules,
                            disabled: !this.isNewRecord,
                            prefix: this.isNewRecord ? `${this.prefix}/` : ''
                        }
                    }
                };
            }
            return {
                name: 'placeHolder',
                label: 'placeholder'
            };
        },
        prefixField() {
            if (
                this.xocAuth &&
                this.isNewRecord &&
                this.prefixItems &&
                this.prefixItems.length > 1
            ) {
                return {
                    name: 'prefix',
                    hideLabel: true,
                    component: {
                        type: 'prefix-select',
                        props: {
                            items: this.prefixItems
                        }
                    }
                };
            }
            return {
                name: 'placeHolder',
                label: 'placeholder'
            };
        },
        formSchema() {
            return [
                {
                    name: 'email',
                    hideLable: true,
                    component: {
                        type: 'v-text-field',
                        props: {
                            label: 'Email *',
                            dense: true,
                            required: true,
                            maxlength: 254,
                            rules: [v => checkEmail(v, 'Email')],
                            disabled: !this.isNewRecord && !this.xocAuth
                        }
                    }
                },
                this.xocAuthField,
                this.prefixField,
                this.usernameField,
                {
                    name: 'firstName',
                    hideLable: true,
                    component: {
                        type: 'v-text-field',
                        props: {
                            label: 'First name *',
                            dense: true,
                            required: true,
                            maxlength: 50
                        }
                    }
                },
                {
                    name: 'lastName',
                    hideLable: true,
                    component: {
                        type: 'v-text-field',
                        props: {
                            label: 'Last name *',
                            dense: true,
                            required: true,
                            maxlength: 50
                        }
                    }
                }
            ];
        }
    }
};
</script>

<style scoped lang="scss">
::v-deep .v-input--checkbox {
    margin-top: 0;
}
</style>
